import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import { Router } from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { UserApi } from './user-api';
import {SharedService} from "../../app/shared/shared.service";
import {DatePipe, LocationStrategy} from "@angular/common";
import {JwtHelper} from "../helpers/jwt";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {DtoLoginResult} from "../../app/shared/models/DtoLoginResult";

@Component({
  selector: 'fw-sign-in',
  template: require('./sign-in.component.html'),
  styles: [require('./sign-in.component.css')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent {
    jwtHelper: JwtHelper = new JwtHelper();
    submitting: boolean;
    form: FormGroup = new FormGroup({
        username: new FormControl('', [Validators.required]),
        password: new FormControl('', [Validators.required]),
        rememberMe: new FormControl(false)
    });
  
  constructor(public userApi: UserApi,
              public ss: SharedService,
              private datepipe: DatePipe,
              private location: LocationStrategy,
              private cd: ChangeDetectorRef,
              private router: Router) { }

    submit(): void {
        if (this.form.valid) {
            this.submitting = true;

            this.userApi.signIn(this.form.value.username, this.form.value.password, this.form.value.rememberMe)
                .pipe(
                    catchError(err => {
                        this.submitting = false;
                        this.cd.detectChanges();
                        return throwError(err);
                    })
                )
                .subscribe((res: DtoLoginResult) => {
                this.processLoginResult(res);
            });
        }
    }

    processLoginResult(res: DtoLoginResult) {
        if (res.hasException) {
            this.submitting = false;
        }
        if (res.inActive) {
            this.ss.message('Uw licentie is verlopen. Neem contact op via het telefoonnummer 0412-629112 om uw licentie te verlengen.');
            this.submitting = false;
        } else if (res.invalidPassword) {
            this.ss.message('Het wachtwoord is onjuist, controleer deze en probeer het opnieuw.');
            this.submitting = false;
        } else if (res.invalidUsername) {
            this.ss.message('De gebruikersnaam is onjuist, controleer deze en probeer het opnieuw.');
            this.submitting = false;
        } else if (res.noOfficeAccount) {
            this.ss.message('Uw licentie heeft geen toegang tot de kantoormodule.');
            this.submitting = false;
        } else if (res.invalidSecurityKey) {
            this.ss.message('De Smart Security Key is onjuist, klik nogmaals de sleutel aan en als dat niet werk controleer of u de juiste sleutel gebruikt.');
            this.submitting = false;
        } else if (res.invalidSecurityKeyIp) {
            this.ss.message('Er kan geen toegang worden gegeven vanaf het de huidige locatie.');
            this.submitting = false;
        } else {
            if (res.blocked)
                this.ss.message(`Uw licentie verloopt over ${30 - res.blockedDays} dagen. Neem contact op via het telefoonnummer 0412-629112 om uw licentie te verlengen`);
            sessionStorage.setItem('accessToken', res.mobileServiceAuthenticationToken);
            sessionStorage.setItem('username', res.username);
            sessionStorage.setItem('expiresOn', this.datepipe.transform(this.jwtHelper.getTokenExpirationDate(res.mobileServiceAuthenticationToken), 'dd-MM-yyyy hh:mm:ss'));
            sessionStorage.setItem('tokenType', 'JWT');
            sessionStorage.setItem('userId', this.jwtHelper.decodeToken(res.mobileServiceAuthenticationToken).nameid);
            sessionStorage.setItem('server', this.jwtHelper.decodeToken(res.mobileServiceAuthenticationToken).DatabaseServer);
            sessionStorage.setItem('database', this.jwtHelper.decodeToken(res.mobileServiceAuthenticationToken).DatabaseName);

            this.router.navigate(['/auth/home']);
        }
        this.cd.detectChanges();
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/users/sign-in.component.ts